import React from "react";

import { FaGear } from "react-icons/fa6";

/**
 * @note This component is not currently implemented in the application but may be
 * updated and used in the future
 *
 * UserPortal component renders a user Portal with a dropdown menu.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.text - Text to display inside the user portrait (this will
 * later become an optional image, with user initials as a fallback)
 *
 * @example
 * return (
 * <UserPortrait text="JD" />
 * )
 */
const UserPortal = ({ text }) => {
  return (
    <div className="user-portal group/usermenu">
      {text}
      <span className="user-menu group-hover/usermenu:scale-100 group-hover/usermenu:opacity-100 group-hover/usermenu:mt-0">
        <span className="flex p-2 mt-10 flex-col cursor-default bg-primary-100 border-1 shadow-lg items-center text-left rounded-md">
          <div className="flex flex-row">
            <p className="mr-1">User Menu</p>
            <FaGear className="m-auto group-hover:animate-spin-once group-hover:duration-300" />
          </div>
        </span>
        <ul className="bg-gray-200 border-1 border-black p-2 rounded-md shadow-lg">
          <li className="p-1 text-left hover:font-extrabold">Profile</li>
          <li className="p-1 text-left hover:font-extrabold">Settings</li>
          <li className="p-1 text-left hover:font-extrabold">Logout</li>
        </ul>
      </span>
    </div>
  );
};

export default UserPortal;
